import type { DefaultTheme } from 'styled-components';
import { darkColors, mapDarkTheme } from './DarkTheme';

export const DarkNeoChainTheme: DefaultTheme = mapDarkTheme(darkColors, {
  name: 'DarkNC',
  backgroundBody: '#363636',
});
